export default __webpack_public_path__ + "static/media/date.40fe0c51.svg";